import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ITopDeviceStatistics } from '@shared/interfaces/admin/statistics';
import { ApiService } from '@shared/services/api.service';
import { BehaviorSubject, Observable, switchMap } from 'rxjs';

export enum TopDeviceRanking {
  BySuccessRate = 'BySuccessRate',
  ByUtilizationRate = 'ByUtilizationRate',
}

@Component({
  selector: 'app-top-devices',
  templateUrl: './top-devices.component.html',
  styleUrls: ['./top-devices.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopDevicesComponent implements OnInit {
  readonly TopDeviceRanking = TopDeviceRanking;

  readonly rankingOptions = [
    {
      label: 'Top 10 by success rate',
      value: TopDeviceRanking.BySuccessRate,
    },
    {
      label: 'Top 10 by utilization rate',
      value: TopDeviceRanking.ByUtilizationRate,
    },
  ];

  readonly selectedRanking$ = new BehaviorSubject<TopDeviceRanking>(
    TopDeviceRanking.BySuccessRate
  );

  statistics$!: Observable<ITopDeviceStatistics[]>;

  showChart = false;

  constructor(private readonly apiService: ApiService) {}

  ngOnInit(): void {
    this.statistics$ = this.selectedRanking$.pipe(
      switchMap((ranking) => this.apiService.getTopDevicesByRanking(ranking))
    );
  }

  onRankingChange(value: TopDeviceRanking): void {
    this.selectedRanking$.next(value);
  }

  toggleView(): void {
    this.showChart = !this.showChart;
  }
}
